/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Col_ChatgptInputs */

const en_mk_cmp_col_chatgpt = /** @type {(inputs: Mk_Cmp_Col_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT`)
};

const id_mk_cmp_col_chatgpt = /** @type {(inputs: Mk_Cmp_Col_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT`)
};

/**
* | output |
* | --- |
* | "ChatGPT" |
*
* @param {Mk_Cmp_Col_ChatgptInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_col_chatgpt = /** @type {((inputs?: Mk_Cmp_Col_ChatgptInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Col_ChatgptInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_col_chatgpt(inputs)
	return en_mk_cmp_col_chatgpt(inputs)
});